import { render, staticRenderFns } from "./BaseBadgeDetail.vue?vue&type=template&id=e59a055c&scoped=true&"
import script from "./BaseBadgeDetail.vue?vue&type=script&lang=js&"
export * from "./BaseBadgeDetail.vue?vue&type=script&lang=js&"
import style0 from "./BaseBadgeDetail.vue?vue&type=style&index=0&id=e59a055c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e59a055c",
  null
  
)

export default component.exports